module.exports = __webpack_public_path__ + "img/bs-monitor.a93e5f4f.svg";